export function processEntityIconInheritance(entities) {
    if (!entities || !entities.length) return [];

    return entities.map(entityData => {
        if (!entityData) return entityData;
        
        const primaryClass = entityData.primaryClass;
        const result = { ...entityData };
        
        result.name = entityData.name || '';
        
        if (entityData.iconName) {
            result.iconName = entityData.iconName;
            result.iconType = entityData.iconType;
        } 
        else if (primaryClass?.icon) {
            result.iconName = primaryClass.icon;
            result.iconType = primaryClass.iconType;
        }
        
        if (entityData.iconColor) {
            result.iconColor = entityData.iconColor;
        } 
        else if (primaryClass?.color) {
            result.iconColor = primaryClass.color;
        }
        
        return result;
    });
}

export default processEntityIconInheritance;